<template>
  <footer
    class="bg-[#F9F8F6] footer-container font-rubik"
    role="contentinfo"
    aria-label="Site footer"
  >
    <div class="w-full h-full flex flex-row justify-center">
      <div class="w-full h-full max-w-1440">
        <!-- ================== MAIN GRID ================== -->
        <div
          class="flex flex-col 1350-bp:grid 1350-bp:grid-cols-4 w-full border-none footer-sections-container"
        >
          <!-- ========= LOGO & MAP ========= -->
          <div class="col-span-1 flex flex-col">
            <div
              class="h-1/4 1350-bp:h-1/2 flex items-start 1350-bp:justify-center justify-start border border-[#E0DAD1] py-10 pl-4 1350-bp:pt-10 1350-bp:pl-0 1350-bp:py-0 border-b-0"
            >
              <a :href="rootPath">
                <img
                  @click="goToHome()"
                  class="logo-image cursor-pointer pt-1"
                  src="@/images/container_alliance_logo.svg"
                  alt="Container Alliance logo"
                />
              </a>
            </div>
            <div
              class="h-3/4 1350-bp:h-1/2 border border-[#E0DAD1] 1350-bp:border-t-0"
            >
              <google-maps
                :apiKey="googleMapsApiKey"
                class="1350-bp:hidden h-full w-full map-container"
              />
            </div>
          </div>

          <!-- ========= LINK COLUMNS ========= -->
          <div class="col-span-3 flex flex-col">
            <!-- ---------- TOP ROW OF LINK NAVS ---------- -->
            <div class="w-full h-full flex flex-col">
              <!-- P01 (three nav columns) -->
              <div class="flex flex-col 1350-bp:flex-row">
                <!-- Customer Guides -->
                <nav
                  class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]"
                  aria-label="Customer Guides"
                >
                  <div class="w-full p01-first-half-container">
                    <h3 class="ft-box-title">Customer Guides</h3>
                    <ul>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="containerBuyersGuideUrl"
                          >Container Buyers Guide</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="refrigeratedBuyersGuideUrl"
                          >Refrigerated Buyers Guide</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="containerRentalGuideUrl"
                          >Container Rental Guide</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="refrigeratedRentalGuideUrl"
                          >Refrigerated Rental Guide</a
                        >
                      </li>
                    </ul>
                  </div>
                </nav>

                <!-- Solutions -->
                <nav
                  class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]"
                  aria-label="Solutions"
                >
                  <div class="w-full p01-first-half-container">
                    <h3 class="ft-box-title">Solutions</h3>
                    <ul>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="containerSalesUrl"
                          >Container Sales</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="containerRentalsUrl"
                          >Container Rentals</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="refrigeratedContainersUrl"
                          >Refrigerated Containers</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="portableOfficesUrl"
                          >Portable Offices</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="soluctionContainerModificationsUrl"
                          >Container Modifications</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="accessoriesUrl"
                          >Container Alliance Accessories</a
                        >
                      </li>
                    </ul>
                  </div>
                </nav>

                <!-- Resources -->
                <nav
                  class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]"
                  aria-label="Resources"
                >
                  <div class="w-full p01-first-half-container">
                    <h3 class="ft-box-title">Resources</h3>
                    <ul>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="resourcesContainerModificationsUrl"
                          >Container Modifications</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="deliveryInformationUrl"
                          >Delivery Information</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="containerConditionsUrl"
                          >Container Conditions</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="shippingContainerSpecificationsUrl"
                          >Container Specifications</a
                        >
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>

              <!-- P02 (three nav columns) -->
              <div class="flex flex-col 1350-bp:flex-row h-full">
                <!-- Company -->
                <nav
                  class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]"
                  aria-label="Company"
                >
                  <div class="w-full p01-first-half-container">
                    <h3 class="ft-box-title">Company</h3>
                    <ul>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="aboutUsUrl"
                          >About Us</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="serviceAreaUrl"
                          >Our Services</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="resourcesContainerModificationsUrl"
                          >Container Modifications</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="partnerProgramUrl"
                          >Partner Program</a
                        >
                      </li>
                    </ul>
                  </div>
                </nav>

                <!-- Contact -->
                <nav
                  class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]"
                  aria-label="Contact"
                >
                  <div class="w-full p01-first-half-container">
                    <h3 class="ft-box-title">Contact</h3>
                    <ul>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          href="/contact"
                          >Contact Us</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          data-vue-init="zip-code-modal"
                          data-props='{"isTypeChange": true}'
                          >Find Inventory</a
                        >
                      </li>
                      <li>
                        <a
                          class="text-footerLinks ft-box-links"
                          href="mailto:info@containeralliance.com"
                          >info@containeralliance.com</a
                        >
                      </li>
                    </ul>
                  </div>
                </nav>

                <!-- Social -->
                <nav
                  class="flex items-start justify-center pt-5 1350-bp:pt-10 pb-5 w-full border border-[#E0DAD1]"
                  aria-label="Social media"
                >
                  <div class="w-full p01-first-half-container">
                    <h3 class="ft-box-title">Social</h3>
                    <ul>
                      <li class="flex">
                        <img
                          class="social-link-icons"
                          src="@/images/header/social/facebook-logo.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="facebookUrl"
                          >Facebook</a
                        >
                      </li>
                      <li class="flex">
                        <img
                          class="social-link-icons"
                          src="@/images/header/social/instagram-logo.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="instagramUrl"
                          >Instagram</a
                        >
                      </li>
                      <li class="flex">
                        <img
                          class="social-link-icons"
                          style="width: 17px; height: 24px;"
                          src="@/images/social-media/X.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="twitter"
                          >X</a
                        >
                      </li>
                      <li class="flex">
                        <img
                          class="social-link-icons"
                          src="@/images/header/social/linkedin-logo.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <a
                          class="text-footerLinks ft-box-links"
                          :href="linkedinUrl"
                          >LinkedIn</a
                        >
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>

            <!-- ---------- CERTIFICATIONS ---------- -->
            <div class="w-full p02-second-half-container">
              <div class="h-1/2 flex justify-evenly">
                <div
                  class="w-full flex items-center justify-center border border-[#E0DAD1]"
                >
                  <a
                    href="https://www.lr.org/en/"
                    rel="nofollow"
                    class="footer-logo text-footerLinks ft-box-links"
                    target="_blank"
                  >
                    <img
                      src="@/images/footer/lloyds-register.svg"
                      alt="Lloyds Register certification"
                    />
                  </a>
                </div>

                <div
                  class="w-full flex items-center justify-center border border-[#E0DAD1]"
                >
                  <a
                    href="https://www.iso.org/iso-9001-quality-management.html"
                    rel="nofollow"
                    class="footer-logo text-footerLinks ft-box-links"
                    target="_blank"
                  >
                    <img
                      src="@/images/footer/quality-systems-certification.svg"
                      alt="ISO 9001 Quality Management certification"
                    />
                  </a>
                </div>

                <div
                  class="w-full flex items-center justify-center border border-[#E0DAD1]"
                >
                  <a
                    href="https://group.bureauveritas.com/"
                    rel="nofollow"
                    class="footer-logo text-footerLinks ft-box-links"
                    target="_blank"
                  >
                    <img
                      src="@/images/footer/bureau-veritas.svg"
                      alt="Bureau Veritas certification"
                    />
                  </a>
                </div>
              </div>

              <div class="h-1/2 flex justify-evenly">
                <div
                  class="w-full flex items-center justify-center border border-[#E0DAD1]"
                >
                  <a
                    href="https://www.iso.org/iso-9001-quality-management.html"
                    rel="nofollow"
                    class="footer-logo text-footerLinks ft-box-links"
                    target="_blank"
                  >
                    <img
                      src="@/images/footer/quality-systems-certification.svg"
                      alt="ISO 9001 Quality Management certification"
                    />
                  </a>
                </div>

                <div
                  class="w-full flex items-center justify-center border border-[#E0DAD1]"
                >
                  <a
                    href="https://www.iso.org/home.html"
                    class="footer-logo text-footerLinks ft-box-links"
                    target="_blank"
                  >
                    <img
                      src="@/images/footer/iso-standard.svg"
                      alt="ISO standard logo"
                    />
                  </a>
                </div>

                <div
                  class="w-full flex items-center justify-center border border-[#E0DAD1]"
                >
                  <a
                    href="https://www.lr.org/en/"
                    rel="nofollow"
                    class="footer-logo text-footerLinks ft-box-links"
                    target="_blank"
                  >
                    <img
                      src="@/images/footer/lloyds-register.svg"
                      alt="Lloyds Register certification"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ================== /MAIN GRID ================== -->
      </div>
    </div>

    <!-- ================== COPYRIGHT BAR ================== -->
    <div class="bg-[#F9F8F6] w-full flex flex-row justify-center font-rubik">
      <div class="h-28 1350-bp:h-16 w-full max-w-1440">
        <div
          class="footer-inner-container border-l-2 border-r-2 border-[#E0DAD1] h-full flex flex-col 1350-bp:flex-row justify-between items-left 1350-bp:items-center text-sm 1350-bp:text-base gap-2 1350-bp:gap-0"
        >
          <div
            class="pl-5 1350-bp:pl-0 flex flex-col 1350-bp:flex-row items-start justify-center gap-3"
          >
            <p class="all-rights-reserved-txt">
              © {{ currentYear }} Container Alliance. All rights reserved.
            </p>

            <nav
              class="flex 1350-bp:flex-row items-center justify-center gap-3 1350-bp:pb-0"
              aria-label="Legal links"
            >
              <a
                class="text-footerLinks all-rights-reserved-txt"
                :href="codeOfEthicsUrl"
                >Code of Ethics</a
              >
              <a
                class="text-footerLinks all-rights-reserved-txt"
                :href="copyrightUrl"
                >Copyright</a
              >
              <a
                class="text-footerLinks all-rights-reserved-txt"
                :href="privacyPolicyUrl"
                >Privacy Policy</a
              >
              <a
                class="text-footerLinks all-rights-reserved-txt"
                :href="termsOfUseUrl"
                >Terms of Use</a
              >
              <a
                class="text-footerLinks all-rights-reserved-txt"
                :href="returnPolicy"
                >Return Policy</a
              >
            </nav>
          </div>

          <!-- Social icons -->
          <div
            class="border-[#E0DAD1] pl-5 1350-bp:pl-0 w-full h-full 1350-bp:w-auto flex items-start 1350-bp:items-center 1350-bp:justify-end gap-4 1350-bp:pr-6"
          >
            <a :href="facebookUrl" aria-label="Facebook"
              ><img
                src="@/images/social-media/facebook-rounded-black.svg"
                alt=""
                aria-hidden="true"
            /></a>
            <a :href="instagramUrl" aria-label="Instagram"
              ><img
                src="@/images/social-media/instagram-bottom.svg"
                alt=""
                aria-hidden="true"
            /></a>
            <a :href="twitter" aria-label="X (formerly Twitter)"
              ><img
                src="@/images/social-media/X.svg"
                alt=""
                aria-hidden="true"
            /></a>
            <a :href="linkedinUrl" aria-label="LinkedIn"
              ><img
                src="@/images/social-media/linkedin-solid.svg"
                alt=""
                aria-hidden="true"
            /></a>
          </div>
        </div>
      </div>
    </div>
    <!-- ================== /COPYRIGHT BAR ================== -->
  </footer>
</template>

<script>
import GoogleMaps from '../google-maps/index.vue'

export default {
  components: {
    GoogleMaps
  },
  props: {
    googleMapsApiKey: {
      required: true,
      type: String
    },

    rootPath: String,
    logoUrl: String,

    containerBuyersGuideUrl: String,
    refrigeratedBuyersGuideUrl: String,
    containerRentalGuideUrl: String,
    refrigeratedRentalGuideUrl: String,

    containerSalesUrl: String,
    containerRentalsUrl: String,
    refrigeratedContainersUrl: String,
    portableOfficesUrl: String,
    containerModificationsUrl: String,
    soluctionContainerModificationsUrl: String,
    accessoriesUrl: String,

    resourcesContainerModificationsUrl: String,
    deliveryInformationUrl: String,
    containerConditionsUrl: String,
    shippingContainerSpecificationsUrl: String,

    aboutUsUrl: String,
    serviceAreaUrl: String,
    partnerProgramUrl: String,

    codeOfEthicsUrl: String,
    copyrightUrl: String,
    contactPageUrl: String,
    privacyPolicyUrl: String,
    termsOfUseUrl: String,
    returnPolicy: String,

    facebookUrl: String,
    instagramUrl: String,
    linkedinUrl: String,
    twitter: String
  },
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer-container {
  width: 100%; 
  height: 907px;
  display: block;
  padding: 0;
}

.footer-inner-container {
  margin-top: 0px;
}

.map-container {
  height: 100%;
}

@media (max-width: 1350px) {
  .map-container {
    height: 400px;
  }
  .footer-container {
    width: 100%; 
    height: auto;
  }
}

.p02-second-half-container {
  height: 100%;
}

.p01-first-half-container {
  padding-left:  32px;
  padding-right:  32px;
}

.footer-sections-container {
  height: 100%;
}

.logo-image {
  width: 220px;
  height: 70.81px;
}

.ft-box-title {
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: #334155;
  margin-bottom: 8px;
}

.ft-box-links {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration-line: none;
  text-decoration-style: solid;
  color: rgba(51, 65, 85, 0.7);
}

.social-link-icons {
  margin-right: 2px;
}

.all-rights-reserved-txt {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  color: #334155;
}

/* mobile */
@media(max-width: 1024px) {
  .footer-container {
    height: auto;
    border: none !important;
  }

  .footer-sections-container {
    height: auto;
  }

  .map-container {
    height: 375px;
  }

  .footer-inner-container {
   padding-top: 15px;
  }

  .p02-second-half-container {
    height: 300px;
  }

  .p01-first-half-container {
    padding: 20px;
  }

  .all-rights-reserved-txt {
    font-size: 10px;
    font-weight: 400;
    line-height: 19.6px;
    letter-spacing: -0.02em;
    color: #334155;
  }
}
</style>
